import React from "react";
import { useTranslation } from "react-i18next";
import { FiArrowRight } from "react-icons/fi";
import { requestTopic, type Topic } from "./Contact";
import "../styles/home.css";

type ServiceRow = { key: Exclude<Topic, "sap">; codes: string[] };

/** Three SAP-first lines of work (spec c.7 §4, COO decision 1). Works with 3 or 4 rows. */
const rows: ServiceRow[] = [
  { key: "finance", codes: ["S/4HANA", "FI", "CO", "CFDI"] },
  { key: "logistics", codes: ["MM", "SD", "EWM", "TM"] },
  { key: "ai", codes: ["OData", "BAPI", "IDoc"] },
];

const Services: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section id="services" className="section" aria-labelledby="services-heading">
      <div className="container">
        <header className="section-head">
          <p className="t-label">{t("services.label")}</p>
          <h2 id="services-heading">{t("services.title")}</h2>
          <p className="t-lead">{t("services.lead")}</p>
        </header>

        <ol className="rows services">
          {rows.map((row, i) => {
            const title = t(`services.items.${row.key}.title`);
            return (
              <li key={row.key} className="service-row">
                <div className="service-head">
                  <span className="service-num" aria-hidden="true">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <h3 className="service-title">{title}</h3>
                </div>
                <div className="service-body">
                  <p>{t(`services.items.${row.key}.text`)}</p>
                  <ul className="chips" aria-label={t("services.codesLabel")}>
                    {row.codes.map((code) => (
                      <li key={code} className="chip">
                        {code}
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="service-action">
                  <a
                    className="link-arrow"
                    href={`?topic=${row.key}#contact`}
                    onClick={(e) => {
                      e.preventDefault();
                      requestTopic(row.key);
                    }}
                  >
                    {t("services.discuss")}
                    <span className="visually-hidden">: {title}</span>
                    <FiArrowRight aria-hidden="true" focusable="false" />
                  </a>
                </div>
              </li>
            );
          })}
        </ol>
      </div>
    </section>
  );
};

export default Services;
